// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/global.css
// module id = 646
// module chunks = 0